"use client";
import "./style.scss";
import classNames from "classnames";
import { ConfigProvider } from "antd";
import { onGetProducts } from "@/api/apiOrder";
import { useState, useEffect, useMemo } from "react";
import { onGetUserPoint } from "@/api/apiOrder";
import { UserPoint } from "@/app/account/components/AccountBody";
import { onCreateOrder } from "@/api/apiOrder";
import Image from "next/image";
import { onLogin } from "@/utils";
import PricingIcon from "@/public/imaegs/pricing.svg";
import UsageLimitIcon from "@/public/imaegs/usage-limit.svg";
import CoreFeaturesIcon from "@/public/imaegs/core-features.svg";
import AdvancedFeaturesIcon from "@/public/imaegs/advanced-features.svg";
import SupportBenefitsIcon from "@/public/imaegs/support-benefits.svg";
import { useMediaSize } from "@/hooks/useMediaSize";
import CustomSegmented from "@/app/use-cases/components/CustomSegmented";

const localProducts = [
  {
    id: "8b6c0f8e-52f5-408d-b70d-ab4105980727",
    title: "Plus Monthly",
    planType: "monthly",
    vipType: "none",
    level: "Free",
    outProductId: "prod_SdiVb5CdYfGCli",
    point: 2000,
    dailyPoint: 300,
    displayAmount: "$0",
    underlinedAmount: "",
    enable: true,
    isMainRecommendation: false,
    createdUser: null,
    btnText: "Free",
    createdAt: "2025-07-08T02:43:00.000Z",
    capacity: [
      {
        text: "1000 Sparks (New User Bonus) - Approximately 4 Tasks",
        icon: "icon-checks_line",
      },
      {
        text: "2 Scheduled Tasks",
        icon: "icon-checks_line",
      },
      {
        text: "Unlimited Concurrent Tasks -Limited Time",
        icon: "icon-checks_line",
      },
      // {
      //   text: "Image generation",
      // },
      // {
      //   text: "Audio generation",
      // },
    ],
  },
  {
    id: "8b6c0f8e-52f5-408d-b70d-ab4105980727",
    title: "Plus Monthly",
    planType: "monthly",
    vipType: "plus",
    level: "Plus",
    outProductId: "prod_SdiVb5CdYfGCli",
    point: 2000,
    dailyPoint: 300,
    displayAmount: "$19.0",
    underlinedAmount: "",
    enable: true,
    isMainRecommendation: false,
    createdUser: null,
    btnText: "Update to Plus",
    createdAt: "2025-07-08T02:43:00.000Z",
    capacity: [
      {
        text: "2000 Sparks/month - Approximately 8 Tasks",
        icon: "icon-checks_line",
      },
      // {
      //   text: "300 refresh sparks everyday",
      //   icon: "icon-gift_line",
      // },
      {
        text: "3 Scheduled Tasks",
        icon: "icon-checks_line",
      },
      {
        text: "Unlimited Concurrent Tasks -Limited Time",
        icon: "icon-checks_line",
      },
      // {
      //   text: "Image generation",
      //   icon: "icon-checks_line",
      // },
      // {
      //   text: "Audio generation",
      //   icon: "icon-checks_line",
      // },
      {
        text: "Priority Support",
        icon: "icon-checks_line",
      },
      {
        text: "Early Access to New Features",
        icon: "icon-checks_line",
      },
    ],
  },

  {
    id: "75ad12a0-fe79-4373-84fb-384095a5a734",
    title: "Pro Monthly",
    planType: "monthly",
    vipType: "pro",
    level: "Pro",
    outProductId: "prod_SdiZLdLwNgnPIS",
    point: 5000,
    dailyPoint: 300,
    displayAmount: "$39.9",
    underlinedAmount: "",
    enable: true,
    isMainRecommendation: true,
    createdUser: null,
    createdAt: "2025-07-08T02:43:00.000Z",
    btnText: "Update to Pro",
    capacity: [
      {
        text: "5000 Sparks/month - Approximately 20 Tasks",
        icon: "icon-checks_line",
      },
      {
        text: "5 Scheduled Tasks",
        icon: "icon-checks_line",
      },
      {
        text: "Unlimited Concurrent Tasks -Limited Time",
        icon: "icon-checks_line",
      },
      // {
      //   text: "Image generation",
      //   icon: "icon-checks_line",
      // },
      // {
      //   text: "Audio generation",
      //   icon: "icon-checks_line",
      // },
      {
        text: "Priority Support",
        icon: "icon-checks_line",
      },
      {
        text: "Early Access to New Features",
        icon: "icon-checks_line",
      },
    ],
  },

  {
    id: "ff341ca9-d22d-45ee-a693-6354c2cc8550",
    title: "Ultra Monthly",
    planType: "monthly",
    vipType: "ultra",
    level: "Ultra",
    outProductId: "prod_SdibtZSEm222Kb",
    point: 28000,
    dailyPoint: 300,
    displayAmount: "$199.9",
    underlinedAmount: "",
    enable: true,
    isMainRecommendation: false,
    createdUser: null,
    createdAt: "2025-07-08T02:43:00.000Z",
    btnText: "Update to Ultra",
    capacity: [
      {
        text: "Unlimited Sparks-Limited Time",
        icon: "icon-checks_line",
      },
      {
        text: "Unlimited Scheduled Tasks",
        icon: "icon-checks_line",
      },
      {
        text: "Unlimited Concurrent Tasks",
        icon: "icon-checks_line",
      },
      // {
      //   text: "Image generation",
      //   icon: "icon-checks_line",
      // },
      // {
      //   text: "Audio generation",
      //   icon: "icon-checks_line",
      // },
      {
        text: "Exclusive Priority Support",
        icon: "icon-checks_line",
      },
      {
        text: "Early Access to New Features",
        icon: "icon-checks_line",
      },
    ],
  },
];

export default function Home() {
  const [planType, setPlanType] = useState("monthly");
  const [vipType, setVipType] = useState("none");
  const [loading, setLoading] = useState(false);
  const [remoteProducts, setRemoteProducts] = useState([]);
  const [isClient, setIsClient] = useState(false);
  const [userPoint, setUserPoint] = useState<UserPoint | null>(null);
  const { isMobile } = useMediaSize();
  const [mobilePlan, setMobilePlan] = useState("none");
  useEffect(() => {
    setIsClient(true);
  }, []);

  useEffect(() => {
    const getProducts = async () => {
      setLoading(true);
      try {
        const res = await onGetProducts();
        console.log(res, "resres dft");
        setRemoteProducts(res.data);
      } catch (error) {
        console.error("Failed to fetch products:", error);
      } finally {
        setLoading(false);
      }
    };
    getProducts();
  }, []);

  useEffect(() => {
    const getUserPoint = async () => {
      try {
        const res = await onGetUserPoint();
        // 模拟数据
        // res.data =
        //  {
        //   id: "38171ea0-a066-44a2-89cc-f0c7f46ebcbc",
        //   userId: "a995ad99-0350-4975-a5e8-b9d88eedd19c",
        //   availablePoint: 99218.32482180001,
        //   usedPoint: 3384.828210599998,
        //   monthlyPoint: 200.0,
        //   monthlyTotalPoint: 100.0,
        //   monthlyResetAt: "2025-07-10T08:31:07.197000",
        //   dailyPoint: 200.0,
        //   dailyTotalPoint: 200.0,
        //   dailyResetAt: "1752651453906",
        //   planType: "yearly", //"single" | "monthly" | "yearly"
        //   updatedAt: "2025-07-16T07:37:33.909000",
        //   createdAt: "2025-06-10T13:31:32.110000",
        //   userName: "zhuowei",
        //   userEmail: "zhuowei@fellou.ai",
        //   userAvatar: "https://files.authing.co/authing-console/default-user-avatar.png",
        //   subscription: {
        //     vipType: "plus", //"none" | "plus" | "pro" | "ultra"）
        //     productId: "xxxx",
        //     planType: "monthly", //"single" | "monthly" | "yearly"
        //   },
        // };

        setUserPoint(res.data || null);
        if (res.data.planType === "monthly" || res.data.planType === "single") {
          setPlanType("monthly");
        } else if (res.data.planType === "yearly") {
          setPlanType("yearly");
        }

        if (res.data?.subscription?.vipType) {
          setVipType(res?.data?.subscription?.vipType);
        }
      } catch (error) {
        console.error("Failed to fetch user point:", error);
        setUserPoint(null);
      }
    };
    getUserPoint();
  }, []);

  const products = useMemo(() => {
    // 本地数据 localProducts 和 远程数据 remoteProducts 合并
    // 以 localProducts 数据的条数为主，vipType 为合并条件，同时按 planType 筛选

    // 先按 planType 筛选远程数据
    const filteredRemoteProducts = remoteProducts.filter((remoteProduct) => remoteProduct.planType === planType);

    // 处理重复的 vipType，后面的覆盖前面的
    const uniqueRemoteProducts = filteredRemoteProducts.reduce((acc, current) => {
      const existingIndex = acc.findIndex((item) => item.vipType === current.vipType);
      if (existingIndex !== -1) {
        // 如果已存在相同 vipType，用当前项覆盖
        acc[existingIndex] = current;
      } else {
        // 如果不存在，添加新项
        acc.push(current);
      }
      return acc;
    }, []);

    const result = localProducts.map((localProduct) => {
      // 在去重后的远程数据中查找相同 vipType 的产品
      const remoteProduct = uniqueRemoteProducts.find((remoteItem) => remoteItem.vipType === localProduct.vipType);
      // 合并数据，本地数据为基础，远程数据覆盖
      return {
        ...localProduct,
        ...remoteProduct,
      };
    });

    return result;
  }, [remoteProducts, planType]);

  const segmentedOptions = [
    { label: <div className="price-method-item">Monthly</div>, value: "monthly" },
    {
      label: (
        <div className="price-method-item">
          Annually{" "}
          <span
            style={{
              // background: "#886AF7",
              // color: "#fff",
              // fontSize: 12,
              // borderRadius: 6,
              // padding: "2px 8px",
              // marginLeft: 8,
              // verticalAlign: "middle",
              // background: "#886AF7",
              background: "#ffffff",
              color: "#5E31D8",
              fontSize: 12,
              lineHeight: "16px",
              borderRadius: 99,
              padding: "1px 8px",
              marginLeft: 8,
              verticalAlign: "middle",
            }}
          >
            save 20%
          </span>
        </div>
      ),
      value: "yearly",
    },
  ];

  const planColumns = [
    { key: "none", label: "Free" },
    { key: "plus", label: "Plus" },
    { key: "pro", label: "Pro" },
    { key: "ultra", label: "Ultra" },
  ];

  const getMonthlyAmount = (vip: string) => {
    if (vip === "none") return "—";
    const found = products.find((p: any) => p.vipType === vip);
    return found?.displayAmount || "—";
  };

  const compareSections = [
    {
      title: "Pricing",
      icon: PricingIcon,
      rows: [
        {
          label: "Monthly",
          values: {
            none: "—",
            plus: getMonthlyAmount("plus"),
            pro: getMonthlyAmount("pro"),
            ultra: getMonthlyAmount("ultra"),
          },
        },
        {
          label: "Annually — Save 20%",
          values: {
            none: "—",
            plus: "$192 ($16/Monthly)",
            pro: "$384 ($32/Monthly)",
            ultra: "$1920 ($160/Monthly)",
          },
        },
      ],
    },
    {
      title: "Usage Limit",
      icon: UsageLimitIcon,
      rows: [
        {
          label: "Monthly Sparks",
          values: {
            none: "—",
            plus: "2000",
            pro: "5000",
            ultra: "Unlimited — Limited Time",
          },
        },
        {
          label: "Concurrent Task",
          values: {
            none: "Unlimited — Limited Time",
            plus: "Unlimited — Limited Time",
            pro: "Unlimited — Limited Time",
            ultra: "Unlimited — Limited Time",
          },
        },
        {
          label: "Scheduled Task",
          values: {
            none: "2",
            plus: "3",
            pro: "5",
            ultra: "Unlimited — Limited Time",
          },
        },
      ],
    },
    {
      title: "Core Features",
      icon: CoreFeaturesIcon,
      rows: [
        {
          label: "Chat",
          values: {
            none: "Free",
            plus: "Free",
            pro: "Free",
            ultra: "Free",
          },
        },
        {
          label: "Deep Search",
          values: {
            none: "Free",
            plus: "Free",
            pro: "Free",
            ultra: "Free",
          },
        },
      ],
    },
    {
      title: "Advanced Features",
      icon: AdvancedFeaturesIcon,
      rows: [
        {
          label: "Visual Report",
          values: {
            none: { type: "Free" },
            plus: { type: "Free", note: "Advanced Model" },
            pro: { type: "Free", note: "Advanced Model" },
            ultra: { type: "Free", note: "Advanced Model" },
          },
        },
        {
          label: "Browser Use",
          values: {
            none: { type: "check" },
            plus: { type: "check" },
            pro: { type: "check" },
            ultra: { type: "check" },
          },
        },
        {
          label: "Computer Use",
          values: {
            none: { type: "check" },
            plus: { type: "check" },
            pro: { type: "check" },
            ultra: { type: "check" },
          },
        },
        {
          label: "Image Agent",
          values: {
            none: { type: "check" },
            plus: { type: "check" },
            pro: { type: "check" },
            ultra: { type: "check" },
          },
        },
        {
          label: "Music Agent",
          values: {
            none: { type: "check" },
            plus: { type: "check" },
            pro: { type: "check" },
            ultra: { type: "check" },
          },
        },
        {
          label: "Code Agent",
          values: {
            none: { type: "check" },
            plus: { type: "check" },
            pro: { type: "check" },
            ultra: { type: "check" },
          },
        },
      ],
    },
    {
      title: "Support & Benefits",
      icon: SupportBenefitsIcon,
      rows: [
        {
          label: "Priority Support",
          values: {
            none: "—",
            plus: { type: "check" },
            pro: { type: "check" },
            ultra: { type: "check" },
          },
        },
        {
          label: "Early Access To New Features",
          values: {
            none: "—",
            plus: { type: "check" },
            pro: { type: "check" },
            ultra: { type: "check" },
          },
        },
      ],
    },
  ];

  const renderCell = (value: any) => {
    if (!value) return <span>—</span>;
    if (typeof value === "string") return <span>{value}</span>;
    if (value?.type === "check") {
      return (
        <div className="plan-cell plan-cell-check">
          <span className="check-dot">✓</span>
          {value.note ? <div className="note">{value.note}</div> : null}
        </div>
      );
    }
    if (value?.type === "Free") {
      return (
        <div className="plan-cell plan-cell-check">
          <span>{value.type}</span>
          {value.note ? <div className="note">{value.note}</div> : null}
        </div>
      );
    }
    return <span>—</span>;
  };

  return (
    <div className="pricing-page">
      <div className="pricing-page-header">
        <div className="pricing-page-header-plan">
          <div className="pricing-page-header-plan-icon">
            <i className="icon iconfont icon-coin_fill"></i>
          </div>
          <div className="pricing-page-header-plan-text">Choose your plan</div>
        </div>
        <div className="pricing-page-header-title">Top-up Sparks</div>
        <div className="pricing-page-header-description">Power your Fellou with sparks</div>
      </div>

      <div
        className="pricing-page-segmented"
        style={{ display: "flex", justifyContent: "center", margin: "84px 0 56px 0" }}
      >
        {isClient ? (
          <ConfigProvider
            theme={{
              components: {
                Segmented: {
                  itemSelectedBg: "rgba(255, 255, 255, 0.16)",
                  itemSelectedColor: "#fff",
                  trackBg: "#1a1a1a",
                  itemHoverColor: "#fff",
                  itemColor: "#8b8892",
                },
              },
            }}
          >
            <CustomSegmented
              isFixedTags={true}
              options={segmentedOptions}
              value={planType}
              onChange={setPlanType}
              block
            />
          </ConfigProvider>
        ) : (
          <div className="segmented-skeleton">
            <div className="segmented-skeleton-item"></div>
            <div className="segmented-skeleton-item"></div>
          </div>
        )}
      </div>

      <div className="pricing-page-cards">
        {products.map((product) => (
          <div
            className={classNames("pricing-page-card", {
              "pricing-page-recommend-card": product.isMainRecommendation,
              "pricing-page-card-vip-none": product.vipType === "none",
            })}
            key={product.vipType}
          >
            {product.isMainRecommendation && (
              <>
                <div className="pricing-page-card-bg">
                  <Image
                    src={"https://cdn.fellou.ai/images/images/home/main-cresits-bg.png"}
                    alt="fellou"
                    fill
                    loading="lazy"
                    unoptimized
                  />
                </div>
                <div className="pricing-page-card-recommend-tag">
                  <i className="icon iconfont icon-star-fill"></i>
                  <div className="pricing-page-card-recommend-tag-text">Most Popular</div>
                </div>
              </>
            )}

            <div className="pricing-page-card-content">
              <div className="pricing-page-card-title">{product.level}</div>
              <div className="pricing-page-card-money">
                <span className="pricing-page-card-money-money">{product.displayAmount}</span>

                <span className="pricing-page-card-money-month">
                  <span className="pricing-page-card-money-underline">{product.underlinedAmount}</span>
                  /month
                </span>
              </div>
              <div
                className={classNames("pricing-page-card-btn", {
                  "pricing-page-card-btn-money": product.vipType !== "none",
                  "pricing-page-card-btn-vip": vipType !== "none",
                  "pricing-page-card-btn-vip-current": vipType === product.vipType && product.vipType !== "none",
                  "pricing-page-card-btn-vip-none": product.vipType === "none",
                })}
                onClick={async () => {
                  if (vipType !== "none" || product.vipType === "none") {
                    return;
                  }

                  const userInfo = localStorage.getItem("fellou.userInfo");

                  if (userInfo) {
                    const res = await onCreateOrder(product.id, window.location.origin + "/account");
                    const paymentUrl = res.data.paymentUrl;
                    window.location.href = paymentUrl;
                  } else {
                    onLogin("stripe", { productId: product.id });
                  }
                }}
              >
                {vipType === product.vipType ? (
                  <div className="pricing-page-card-btn-text">Current Plan</div>
                ) : (
                  <div className="pricing-page-card-btn-text">{product.btnText}</div>
                )}
              </div>
              <div className="pricing-page-card-capacity">
                {product.capacity.map((item, itemIndex) => (
                  <div className="pricing-page-card-capacity-item" key={`${product.vipType}-${itemIndex}`}>
                    <div className="pricing-page-card-capacity-item-icon">
                      <i className={`icon iconfont ${item.icon}`}></i>
                    </div>
                    <div className="pricing-page-card-capacity-item-text">{item.text}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="pricing-page-remind">
        <div className="pricing-page-remind-icon">
          <i className="icon iconfont icon-warning_line"></i>
        </div>
        <div className="pricing-page-remind-text">
          Actual consumption varies significantly based on workflow complexity. Above estimates are for reference only.
        </div>
      </div>
      {isMobile ? (
        <div className="pricing-compare-plans-mobile">
          <div className="compare-title">Compare plans</div>
          {/* <div className="mobile-plan-tabs">
            {planColumns.map((col) => (
              <button
                key={`m-tab-${col.key}`}
                className={classNames("mobile-plan-tab", { active: mobilePlan === col.key })}
                onClick={() => setMobilePlan(col.key)}
              >
                {col.label}
              </button>
            ))}
          </div> */}

          <div className="compare-table">
            <div className="compare-header">
              <div className="cell label">Function/Benefit</div>
              {planColumns.map((col) => (
                <div className="cell" key={`m-head-${col.key}`}>
                  {col.label}
                </div>
              ))}
            </div>

            {compareSections.map((section, sIdx) => (
              <div className="compare-section" key={`m-section-${sIdx}`}>
                <div className="m-section-title">
                  <span className="m-icon">
                    <Image src={section.icon} alt={section.title} width={18} height={18} />
                  </span>
                  <span>{section.title}</span>
                </div>
                {section.rows.map((row, rIdx) => (
                  <div className="compare-row" key={`m-row-${sIdx}-${rIdx}`}>
                    <div className="cell label">{row.label}</div>
                    {planColumns.map((col) => (
                      <div className="cell" key={`m-cell-${sIdx}-${rIdx}-${col.key}`}>
                        {renderCell((row as any).values[col.key])}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="pricing-compare-plans">
          <div className="compare-title">Compare plans</div>
          <div className="compare-table">
            <div className="compare-header">
              <div className="cell label">Function/Benefit</div>
              {planColumns.map((col) => (
                <div className="cell" key={col.key}>
                  {col.label}
                </div>
              ))}
            </div>

            {compareSections.map((section, sIdx) => (
              <div className="compare-section" key={`section-${sIdx}`}>
                <div className="section-title">
                  <div className="section-icon">
                    <Image src={section.icon} alt={section.title} width={18} height={18} />
                  </div>
                  <span>{section.title}</span>
                </div>
                {section.rows.map((row, rIdx) => (
                  <div className="compare-row" key={`row-${sIdx}-${rIdx}`}>
                    <div className="cell label">{row.label}</div>
                    {planColumns.map((col) => (
                      <div className="cell" key={`cell-${sIdx}-${rIdx}-${col.key}`}>
                        {renderCell(row.values[col.key])}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
